const isGroupedOptin = (item)=>'groupedOptIns' in item
;
var FormName;
(function(FormName) {
    FormName["personalDetails"] = "personalDetails";
    FormName["billingAddress"] = "billingAddress";
    FormName["preferredStore"] = "preferredStore";
    FormName["signUp"] = "signUp";
})(FormName || (FormName = {}));

export { FormName, isGroupedOptin };
//# sourceMappingURL=types.js.map
